<div class="bg-white w-full" *ngIf="webComponent">
    <mft-wc-wrapper [options]="webComponent.options" [props]="webComponent.props"
        [events]="webComponent.events"></mft-wc-wrapper>

    <!-- <div *ngIf="!isLoading" class="grid grid-cols-1 md:grid-cols-4 gap-4 border mx-4">
        <div class="flex flex-col items-center">
            <span class="font-bold text-lg">Annulus A</span>
            <div id="chartAnullusA" class="w-full h-[250px]"></div>
        </div>

        <div class="flex flex-col items-center">
            <span class="font-bold text-lg">Annulus B</span>
            <div id="chartAnullusB" class="w-full h-[250px]"></div>
        </div>

        <div class="flex flex-col items-center">
            <span class="font-bold text-lg">Annulus C</span>
            <div id="chartAnullusC" class="w-full h-[250px]"></div>
        </div>

        <div class="flex flex-col items-center">
            <span class="font-bold text-lg">Annulus D</span>
            <div id="chartAnullusD" class="w-full h-[250px]"></div>
        </div>
    </div> -->
</div>